
import { ref } from 'vue';
import { teamApi } from '@/shared/teams/team-api';
import { reverse } from 'lodash';
import Season from '@/shared/seasons/season';
import { useStore } from 'vuex';
import { watch } from 'vue';

function useSeasons() {
  const seasonsList = ref<number[]>([]);
  const currentSeason = ref<Season>();
  const store = useStore();

  async function getSeasons() {
    currentSeason.value = await teamApi.getMatchups(store.state.leagueId);
    seasonsList.value = seasonsList.value.concat(currentSeason.value.status.previousSeasons);
    seasonsList.value.push(currentSeason.value.seasonId);
    seasonsList.value = reverse(seasonsList.value);
  }

  watch(
    () => store.state.leagueId,
    () => {
      seasonsList.value = [];
      getSeasons();
    }
  )

  getSeasons();

  return {
    seasonsList,
  }
}

export default {
  setup() {
    return useSeasons();
  }
}
